import { type MCPServerInfo } from '../../types';

const HubspotServer: MCPServerInfo = {
  serverId: 'HUBSPOT',
  name: 'Hubspot',
  slug: 'hubspot',
  description: 'Hubspot MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'mcp/hubspot:latest',
    commitSha: 'latest',
    packageType: 'npm',
    packageName: '@hubspot/mcp-server'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['privateAppAccessToken'],
    properties: {
      privateAppAccessToken: {
        type: 'string',
        description: 'privateAppAccess Token',
        sensitive: true
      }
    }
  }
};

export default HubspotServer;
